import React from "react";
import img1 from "../assets/img/about/about.jpg";
import img2 from "../assets/img/about/about-2.jpg";
import img3 from "../assets/img/about/about-3.jpg";
import img4 from "../assets/img/about/about-4.jpg";
import img5 from "../assets/img/about/about-5.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useTranslation } from "react-i18next";


const Place = () => {
 const { t } = useTranslation("special");

  return (
    <div className="mt-16 bg-[#1a1208] relative overflow-hidden py-20 px-6">

      {/* Grain overlay */}
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.035]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
          backgroundSize: "200px",
        }}
      />

      {/* Ambient glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 60% 50% at 80% 30%, rgba(139,90,43,0.18) 0%, transparent 70%), radial-gradient(ellipse 40% 60% at 10% 80%, rgba(93,55,20,0.22) 0%, transparent 70%)",
        }}
      />

      {/* ── Title ── */}
      <div className="relative text-center mb-14">
        <span
          className="block mb-3 text-[#c8a96e] uppercase tracking-[0.3em] text-[11px] font-light"
          
        >
          {t("place_eyebrow")}
        </span>

        <h1
          className="text-4xl font-normal text-[#f5edd8] mb-4"
          
        >
          {t("place_title")}
        </h1>

        {/* Decorative divider */}
        <div className="flex items-center justify-center gap-4">
          <span className="block h-px w-16" style={{ background: "linear-gradient(to right, transparent, #c8a96e)" }} />
          <span className="block w-1.5 h-1.5 rounded-full bg-[#c8a96e] opacity-80" />
          <span className="block h-px w-16" style={{ background: "linear-gradient(to left, transparent, #c8a96e)" }} />
        </div>
      </div>

      {/* ── Content ── */}
      <div className="relative flex flex-col-reverse md:flex-row items-center gap-12 max-w-5xl mx-auto">

        {/* Text Section */}
        <div className="w-full md:w-1/2 text-center md:text-left">
          <span
            className="inline-block mb-5 text-[#c8a96e] text-[10px] uppercase tracking-[0.25em] font-light border border-[rgba(200,169,110,0.35)] px-3 py-1 rounded-sm"
            
          >
            {t("place_tag")}
          </span>

          <h2
            className="text-4xl font-semibold text-[#f5edd8] mb-1 leading-tight"
            
          >
            {t("place_subtitle")}
          </h2>

          <p
            className="text-[rgba(240,232,216,0.72)] text-lg font-light leading-relaxed mt-5 mb-8"
            
          >
            {t("place_desc")}
          </p>
        </div>

        {/* Swiper Section */}
        <div className="w-full md:w-1/2 p-2 relative">

          {/* Decorative offset frame */}
          <div
            className="absolute pointer-events-none rounded-sm"
            style={{
              top: -10,
              left: -10,
              right: 18,
              bottom: 18,
              border: "0.5px solid rgba(200,169,110,0.25)",
              zIndex: 0,
            }}
          />

          <div className="relative z-10 rounded-lg overflow-hidden shadow-2xl">
            <Swiper
              modules={[Autoplay, Pagination]}
              autoplay={{ delay: 3000 }}
              pagination={{ clickable: true }}
              loop={true}
              className="rounded-lg shadow-md"
            >
              {[img5, img1, img2, img3, img4].map((image, i) => (
                <SwiperSlide key={i}>
                  <img
                    src={image}
                    alt={`Restaurant ${i + 1}`}
                    className="w-full h-80 object-cover rounded-lg"
                  />
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Gradient caption overlay */}
            <div
              className="absolute bottom-0 left-0 right-0 z-10 pointer-events-none px-5 pb-4 pt-10"
              style={{ background: "linear-gradient(to top, rgba(15,9,3,0.88) 0%, transparent 100%)" }}
            >
              <p
                className="text-[#f5edd8] italic text-lg m-0"
                
              >
                Mantic Cup
              </p>
              <p
                className="text-[rgba(200,169,110,0.7)] text-[10px] uppercase tracking-widest m-0"
                
              >
                Café · Tea Room · Phnom Penh
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* ── Bottom strip ── */}
      <div
        className="relative flex flex-wrap items-center justify-center gap-10 mt-16 pt-8"
        style={{ borderTop: "0.5px solid rgba(200,169,110,0.15)" }}
      >
        {[
          { icon: "☕", label: t("strip_coffee") },
          { icon: "🍃", label: t("strip_tea") },
          { icon: "🍽", label: t("strip_kitchen") },
          { icon: "🪑", label: t("strip_space") },
        ].map((item, i, arr) => (
          <div key={i} className="flex items-center gap-10">
            <div className="text-center">
              <span className="block text-xl mb-1">{item.icon}</span>
              <span
                className="text-[rgba(240,232,216,0.45)] text-[10px] uppercase tracking-[0.18em] font-light"
                
              >
                {item.label}
              </span>
            </div>
            {i < arr.length - 1 && (
              <div className="hidden sm:block w-px h-7 bg-[rgba(200,169,110,0.2)]" />
            )}
          </div>
        ))}
      </div>

    </div>
  );
};

export default Place;
